import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import AuthLayout from "./AuthLayout";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(form.email, form.password);
      navigate(u.role === "super_admin" ? "/admin" : "/app");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Welcome back" subtitle="Sign in to your LeadVault workspace.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div><Label htmlFor="email">Email</Label><Input id="email" type="email" required className="mt-1.5 h-11" data-testid="login-email-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
        <div>
          <div className="flex justify-between"><Label htmlFor="password">Password</Label><Link to="/forgot-password" className="text-xs text-primary hover:underline" data-testid="forgot-password-link">Forgot password?</Link></div>
          <Input id="password" type="password" required className="mt-1.5 h-11" data-testid="login-password-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        </div>
        {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
        <Button type="submit" className="w-full h-11" disabled={busy} data-testid="login-submit-button">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Sign in</Button>
        <p className="text-sm text-center text-muted-foreground">New agency? <Link to="/register" className="text-primary font-medium hover:underline" data-testid="register-link">Create an account</Link></p>
      </form>
    </AuthLayout>
  );
}
